import React, { useMemo } from 'react';

import { AppliedFilters } from '../../shared/applied-filters';
import { Condition } from '../../shared/condition';
import { FilteredProductCount } from '../../shared/filtered-product-count';
import { getRequirementsFromRequirementStepState } from '../../shared/helpers';
import { useDiscountWizardStateContext } from '../../state';

import { AppliedFiltersWrapper } from './styled';
import { SummaryCard } from './summary-card';

import type { SummaryCardProps } from './summary-card';

export function RequirementsCard({ onEditClick }: { onEditClick: () => void }) {
  const { requirementsStepState } = useDiscountWizardStateContext();

  const requirements = getRequirementsFromRequirementStepState(requirementsStepState);

  const rows = useMemo(() => {
    const rows: SummaryCardProps['rows'] = Object.keys(requirements)
      .map((requirement) => [
        { fieldTitle: `Requirement ${requirement}`, fieldValue: '' },
        { fieldTitle: 'Condition:', fieldValue: <Condition requirement={Number(requirement)} /> },
        {
          fieldTitle: 'Filters applied:',
          fieldValue: (
            <AppliedFiltersWrapper>
              <AppliedFilters excludeCommas requirement={Number(requirement)} />
            </AppliedFiltersWrapper>
          ),
        },
        { fieldTitle: 'Eligible products:', fieldValue: <FilteredProductCount requirement={Number(requirement)} /> },
      ])
      .flat();

    return rows;
  }, [requirements]);

  return <SummaryCard rows={rows} title='Requirements' onEditClick={onEditClick} />;
}
